import { Project as ProjectBreadcrumb } from '../../../breadcrumbs/models/Project';
import { Report as ReportBreadcrumb } from '../../../breadcrumbs/models/Report';
import { Slot as SlotBreadcrumb } from '../../../breadcrumbs/models/Slot';
import { GQLIdEncoder, ModelType } from '../../../common/utils/GQLIdEncoder';
import { Report } from '../models/Report';

export class ReportBreadcrumbMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapToBreadcrumb(report: Report): ReportBreadcrumb {
    const slot = report.getSlot();
    const project = report.getProject();

    const mappedProject = project
      ? new ProjectBreadcrumb(this.gqlIdEncoder.encode(ModelType.Project, project.getId()), project.getId(), project.getName())
      : null;
    const mappedSlot = slot ? new SlotBreadcrumb(this.gqlIdEncoder.encode(ModelType.Slot, slot.getId()), slot.getId(), slot.getName(), mappedProject) : null;
    return new ReportBreadcrumb(
      this.gqlIdEncoder.encode(ModelType.Report, report.getId()),
      report.getId(),
      report.getName(),
      report.getTraceType(),
      mappedSlot
    );
  }
}
